/* global ApeConfig */
import React from 'react';
import { Col, Row, Flex, Select, Input, Pagination, Spin, Checkbox, Tooltip, Button, Table, Modal, InputNumber, theme } from 'antd';
import Switch from "react-switch";
import { formatEther, parseEther, parseUnits } from 'ethers/utils';
import Moment from 'react-moment';
import { TwitterIcon, TelegramIcon, WebIcon, SearchIcon, SettingsIcon, DexScreenerIcon } from './ApeIcons';
import { ChainDisplay, ChainSelect } from '../shared/ChainSelect';
import { useLocalState } from '../../App'
import { ProtocolDisplay } from '../shared/ProtocolDisplay';
import { TokenLogo } from './TokenLogo';
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useNavigate } from "react-router-dom";
import { usePermissions } from '../context/PermissionsContext';
import { SocialIcon } from '../shared/SocialIcon'
import { UserIcon } from '../shared/UserIcon'
import { DownOutlined, ThunderboltFilled, ThunderboltOutlined, EyeFilled, UnorderedListOutlined, AppstoreOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { useSockets } from '../context/SocketsContext';
import { useAnimation } from '../context/AnimationContext';
import { BrowserProvider, Contract } from 'ethers'
import { ApeStoreProxyAbi } from './ApeStoreContract';
import { notification } from 'antd';
import { useWeb3ModalProvider, useWeb3ModalAccount } from '@web3modal/ethers/react'
import { createStyles } from 'antd-style';

const useStyle = createStyles(({ css, token }) => {
	const { antCls } = token;
	return {
		customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
	};
});

const { Column } = Table;
const { Text } = Typography;


export const ApeGrid = ({ items, page, setPage, sort, setSort, order, setOrder, search, setSearch, filter, setFilter, chain, setChain, pages, showPager = true }) => {
	const { mobile } = useSockets();
	const { isAdmin, isAuthenticated } = usePermissions();
	const { enableAnimation, setEnableAnimation } = useAnimation();
	const [showFilter, setShowFilter] = React.useState(false);
	const [swapping, setSwapping] = React.useState(false);
	const [listView, setListView] = useLocalState(false, "list.view");
	const [buy1, setBuy1] = useLocalState("0.01", "list.buy1");
	const [buy2, setBuy2] = useLocalState("0.05", "list.buy2");
	const [buy3, setBuy3] = useLocalState("0.1", "list.buy3");
	const [showSettings, setShowSettings] = React.useState(false);
	const navigate = useNavigate();
	const { styles } = useStyle();

	const onChangePage = (page) => {
		setPage(Math.min(pages, page - 1));
	};

	const onToggleAnimations = async () => {
		await setEnableAnimation(!enableAnimation);
		window.location.reload();
	};

	const toggleShowFilter = () => {
		setShowFilter(!showFilter);
	}

	const formatNumber = (value, digits = 4) => {
		return value ? Intl.NumberFormat('en-US', {
			notation: "compact",
			maximumFractionDigits: digits
		}).format(value) : 0;
	};

	const formatPrice = (value) => {
		const r = /\.([0]*)([^0][0-9]{1,3})[0-9]*$/;
		const match = value.toString().match(r);
		if (match && match[1].length > 0) {
			let aboveZero = Math.floor(value);
			let zeros = match[1].length;

			return <>
				<span>${`${aboveZero}.0`}</span>
				<span style={{ fontSize: '8px', paddingTop: '4px'  }}>{zeros}</span>
				<span>{match[2]}</span>
			</>;
		} else {
			return formatNumber(value);
		}
	};

	const getPercentChange = (currentPrice, lastPrice) => {
		var change = currentPrice - lastPrice;

		return isNaN(change) || change === 0 || isFinite(change / lastPrice) === false ?
			<span>-</span> :
			change > 0 ?
				<span style={{ color: '#48BB78' }}>{formatNumber(change / lastPrice * 100, 1)}%</span> :
				<span style={{ color: '#F56565' }}>{formatNumber(change / lastPrice * 100, 1)}%</span>
	}

	const lookupChain = (chain) => {
		return ApeConfig.find(x => x.Short === chain || x.ID === chain)?.Short ?? chain;
	}


	const derrivedPage = Math.min(page, pages);
	const config = ApeConfig.find(x => x.Short === 8453 || x.ID == 8453);


	return <>
		<Row style={{ background: 'rgb(27, 29, 40)', zIndex: 1, position: 'relative' } }>
			<Col xs={24} style={{ padding: '20px' }} >
				<Flex justify="space-between" width="100%" style={{ flexWrap: "wrap"}}>
					<Flex align="center" gap={5}>
					<Select
						value={sort}
						onChange={(value) => { setSort(value) }}
						size="small"
						style={{ width: '150px', height: '32px', background: '#282A34', border: '1px solid #282A34' }}
						suffixIcon={<DownOutlined style={{ display: 'none' }} />}
						options={[
							{ value: 0, label: 'Creation Time' },
							{ value: 1, label: 'Live Updates' },
							{ value: 2, label: 'Market Cap' },
							{ value: 3, label: 'Replies' }
						]}
					/>
					<Select
						value={order}
						onChange={(value) => { setOrder(value) }}
						size="small"
						style={{ width: '40px', height: '32px' }}
						suffixIcon={<DownOutlined style={{ display: 'none' }} />}
						options={[
							{ value: 0, label: <><span style={{ color: '#86efac' }}>↓</span>↑</> },
							{ value: 1, label: <>↓<span style={{ color: '#86efac' }}>↑</span></> }
						]}
					/>

					{mobile ? <></>	:
						<>
							<ChainSelect chainId={chain} setChainId={setChain} mobile={mobile} />
							<Select
								value={filter}
								onChange={(value) => { setFilter(value) }}
								size="small"
								style={{ width: mobile ? '75px' : '150px', height: '32px' }}
								suffixIcon={<DownOutlined style={{ display: 'none' }} />}
								options={[
									{ value: 0, label: mobile ? 'All' : 'All' },
									{ value: 1, label: mobile ? 'Active' : 'Active' },
									{ value: 2, label: mobile ? 'Free' : 'Free' }
								]}
							/>
						</>
					}

					<Input size="large" maxLength={48} style={{ width: '145px', height: '32px' }} placeholder="Search" value={search} onChange={(evt) => { setSearch(evt.target.value); }} prefix={<SearchIcon size={10} />} />

					{mobile ? <Tooltip title="More Filters">
						<div>
							<SocialIcon size={16} onClick={() => toggleShowFilter()} icon={SettingsIcon} />
						</div>
					</Tooltip> : <></>}
					</Flex>
					<Flex gap={5} align="center" justify="center">		
						{/*<Select*/}
						{/*	value={listView}*/}
						{/*	onChange={(value) => { setListView(value) }}*/}
						{/*	size="small"*/}
						{/*	style={{ width: mobile ? '75px' : '150px', height: '32px' }}*/}
						{/*	suffixIcon={<DownOutlined style={{ display: 'none' }} />}*/}
						{/*	options={[*/}
						{/*		{ value: false, label: 'Grid Mode' },*/}
						{/*		{ value: true, label: 'List Mode' }*/}
						{/*	]}*/}
						{/*/>*/}
						{listView ?
							<Tooltip title="Adjust Quick Buy">
								<Button style={{ backgroundColor: "#232432", borderColor: "#232432", paddingTop: "5px" }}>
									<SocialIcon size={16} onClick={() => setShowSettings(true)} icon={SettingsIcon} />
								</Button>
							</Tooltip>
							: <></>}
						<Switch
							onChange={(value) => { setListView(value) }}
							checked={listView}
							onColor="#232432"
							offColor="#232432"
							offHandleColor="#48BB78"
							onHandleColor="#48BB78"
							className="react-switch"
							uncheckedIcon={
								<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 20, color: "rgb(78, 78, 78)", width: "30px" }}>
									<UnorderedListOutlined />
								</div>
							}
							checkedIcon={
								<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 20, color: "rgb(78, 78, 78)", width: "30px" }}>
									<AppstoreOutlined />
								</div>
							}
							uncheckedHandleIcon={
								<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 20, color: "#fff"}}>
									<AppstoreOutlined />
								</div>
							}
							checkedHandleIcon={
								<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 20, color: "#fff" }}>
									<UnorderedListOutlined />
								</div>
							}
						/>

					</Flex>
				</Flex>
				{showFilter && mobile ? <Flex vertical style={{ width: '100%' }}>
					<h5 style={{ margin: 4 }}>Network</h5>
					<ChainSelect chainId={chain} setChainId={setChain} mobile={false} />
					<h5 style={{ margin: 4}}>Status</h5>
					<Select
						value={filter}
						onChange={(value) => { setFilter(value) }}
						size="small"
						style={{ width: '150px', height: '32px' }}
						suffixIcon={<DownOutlined style={{ display: 'none' }} />}
						options={[
							{ value: 0, label: mobile ? 'All' : 'All' },
							{ value: 1, label: mobile ? 'Active' : 'Active' },
							{ value: 2, label: mobile ? 'Free' : 'Free' }
						]}
					/>
					<Tooltip title={enableAnimation ? "Disable animations" : "Enable animations"}>
						<Button type="primary" onClick={onToggleAnimations}>
							{enableAnimation ? <ThunderboltFilled /> : <ThunderboltOutlined />}
						</Button>
					</Tooltip>
				</Flex> : <></>}
			</Col>
		</Row>
		{listView ?
			<Row>
				<Table scroll={{ x: 'max-content' }} dataSource={items} pagination={false} key="apelist" style={{ width: mobile ? "auto" : "100%" }} rootClassName="ape-list" className={styles.customTable} showSorterTooltip={{ target: 'sorter-icon' }}>
					<Column title="Token" key="name" fixed="left" render={(row) => (
						
						<Flex justify="space-between" key={`ape-list-row-${row.id}`}>
								<Flex align="center" gap={5} style={{ cursor: "pointer"}} onClick={() => navigate(`/${lookupChain(row.chain)}/${row.address}`) }>
										<div><TokenLogo value={row} size={30} /></div>
										<div><ProtocolDisplay token={row} /></div>
										<div>{row.symbol}</div>
										<div><ChainDisplay chain={row.chain} /></div>
									</Flex>
						</Flex>
					)} />
					<Column title="Socials" key="socials" width="140px" render={(_, row) => (
						<Flex justify="flex-start">
							{row.website ? <SocialIcon component={Text} icon={WebIcon} href={row.website} style={{ margin: "5px" }} /> : <></>}
							{row.telegram ? <SocialIcon component={Text} icon={TelegramIcon} href={row.telegram} style={{ margin: "5px" }} /> : <></>}
							{row.twitter ? <SocialIcon component={Text} icon={TwitterIcon} href={row.twitter} style={{ margin: "5px" }} /> : <></>}
							{row.dexPaid ? <SocialIcon component={Text} icon={DexScreenerIcon} href={`https://marketplace.dexscreener.com/order-status/${lookupChain(row.chain)}/${row.address}`} style={{ margin: "5px" }} /> : <></>}
							<div></div>
						</Flex>
					)} />
					<Column title="Age" key="deployDate" sorter={(a, b) => new Date(a.deployDate) - new Date(b.deployDate)} render={(_, row) => (
						<Moment fromNow>{`${row.deployDate}${row.deployDate.endsWith("Z") ? "" : "Z"}`}</Moment>
					)} />
					<Column title="MCAP" key="mcap" sorter={(a, b) => a.marketCap - b.marketCap} render={(_, row) => (
						<>${formatNumber(row.marketCap)}</>
					)} />
					<Column title="Price" key="price" sorter={(a, b) => a.marketCap - b.marketCap} render={(_, row) => (
						<>{formatPrice(row.marketCap / 1000000000)}</>
					)} />
					<Column title="1H" key="1h" sorter={(a, b) => ((a.priceAfter ?? a.price) - a.price1H) - ((b.priceAfter ?? b.price) - b.price1H)} render={(_, row) => (
						<>{getPercentChange(row.priceAfter ?? row.price, row.price1H)}</>
					)} />
					<Column title="24H" key="24h" sorter={(a, b) => ((a.priceAfter ?? a.price) - a.price24H) - ((b.priceAfter ?? b.price) - b.price24H)} ter render={(_, row) => (
						<>{getPercentChange(row.priceAfter ?? row.price, row.price24H)}</>
					)} />
					<Column title="Volume" key="volume" sorter={(a, b) => a.volumeStat?.volumeUSD - b.volumeStat?.volumeUSD} render={(_, row) => (
						<>${formatNumber(row.volumeStat?.volumeUSD, 1)}</>
					)} />
					<Column title="Makers" key="makers" sorter={(a, b) => a.volumeStat?.transactions - b.volumeStat?.transactions} render={(_, row) => (
						<>{row.volumeStat?.transactions}</>
					)} />
					<Column title="DEX Paid" key="dex-paid" sorter={(a, b) => a.dexPaid - b.dexPaid} render={(row) => (
						<>{row.dexPaid ? <>Yes</> : <>-</>}</>
					)} />
					<Column title="Quick Buy" key="quick-buy" width="140px" render={(_, row) => (
						<QuickBuy token={row} buy1={buy1} buy2={buy2} buy3={buy3} swapping={swapping} setSwapping={setSwapping}></QuickBuy>
					)} />
					{/*<Column title="DEV Holds" key="dev-holds" render={(_, row) => (*/}
					{/*	<></>*/}
					{/*)} />*/}
					{/*<Column title="Top 10" key="top-10" render={(_, row) => (*/}
					{/*	<></>*/}
					{/*)} />*/}
				</Table>
			</Row> :
			<Row>
				<div style={{ display: 'flex', justifyContent: "space-evenly", width: '100%', flexWrap: 'wrap',}}>
					{items.map((row, index) => {
						return (
							<div key={`${row.id}`} timeout={300} style={{ margin: '10px'}}>
								<Item value={row} />
							</div>
						);
					})}
				</div>			
			</Row>
		}
		{showPager ?
			<Row align="center" style={{ paddingBottom: '20px' }}>
				<Pagination rootClassName="grid-pager" current={derrivedPage + 1} onChange={onChangePage} defaultPageSize={18} simple showSizeChanger={false} total={pages} />
			</Row> : <></>
		}
		<Modal title="Instant Buy Settings" open={showSettings} closable={false} width="200px" footer={[
			<Button key="back" onClick={() => setShowSettings(false)}>
				OK
			</Button>]}>
			<Flex style={{ padding: 0, marginTop: '10px' }} gap={5} vertical>
				<div>Value 1: <InputNumber min={0} value={buy1} onChange={(v) => { setBuy1(v); }} controls={false} stringMode />
					</div>
				<div>Value 2: <InputNumber min={0} value={buy2} onChange={(v) => { setBuy2(v); }} controls={false} stringMode />
					</div>
				<div>Value 3: <InputNumber min={0} value={buy3} onChange={(v) => { setBuy3(v); }} controls={false} stringMode />
					</div>
			</Flex>
		</Modal>
	</>


}

export const QuickBuy = ({ token, buy1, buy2, buy3, swapping, setSwapping }) => {
	const { address, chainId, isConnected } = useWeb3ModalAccount();
	const { walletProvider } = useWeb3ModalProvider();
	const [api, contextHolder] = notification.useNotification();

	const openNotification = (title, message, style) => {
		api.open({
			message: title,
			description: message,
			style: style,
			placement: "bottomRight"
		});
	};

	const handleSwap = async (buyAmount) => {
		buyAmount = buyAmount.toString();
		const config = ApeConfig.find(x => x.ID === token.chain);
		if (token.launchDate != null && token.protocol === 2) {
			try {
				setSwapping(true);
				const ethersProvider = new BrowserProvider(walletProvider);
				const signer = await ethersProvider.getSigner();
				const apeStore = new Contract(config.ApeProxy, ApeStoreProxyAbi, signer);
				let hash = (await apeStore.buy(0, [config.Wrapped, token.address], address, Math.round(Date.now() / 1000 + 60).toString(), { value: parseEther(buyAmount) })).hash;
				await ethersProvider.waitForTransaction(hash, 1);
				openNotification("Swap Confirmed", "", { border: 'solid 1px #86EFAC', borderRadius: '18px' });
			} catch (err) {
				console.error(err);
				openNotification("Swap Failed", err.message, { border: 'solid 1px red', borderRadius: '18px' });
			} finally {
				setSwapping(false);
			}
		} else if (token.protocol === 3) {
			try {
				setSwapping(true);
				const ethersProvider = new BrowserProvider(walletProvider);
				const signer = await ethersProvider.getSigner();
				const apeStore = new Contract(config?.ApeV3Routers[config.ApeV3Routers.length - 1], ApeStoreProxyAbi, signer);
				let hash = (await apeStore.exactEthInputSingle({
						tokenIn: config.Wrapped,
						tokenOut: token.address,
						fee: "10000",
						recipient: address,
						amountIn: parseEther(buyAmount),
						amountOutMinimum: 0,
						sqrtPriceLimitX96: "0"
					}, { value: parseEther(buyAmount) })).hash;


				await ethersProvider.waitForTransaction(hash, 1);
				openNotification("Swap Confirmed", "", { border: 'solid 1px #86EFAC', borderRadius: '18px' });
			} catch (err) {
				console.error(err);
				openNotification("Swap Failed", err.message, { border: 'solid 1px red', borderRadius: '18px' });
			} finally {
				setSwapping(false);
			}
		} else if (token.protocol === 30) {
			try {
				setSwapping(true);
				const ethersProvider = new BrowserProvider(walletProvider);
				const signer = await ethersProvider.getSigner();
				const apeStore = new Contract(config?.ApeProxy, ApeStoreProxyAbi, signer);
				let hash = (await apeStore.exactEthInputSingle({
						tokenIn: config.Wrapped,
						tokenOut: token.address,
						fee: "10000",
						recipient: address,
						amountIn: parseEther(buyAmount),
						amountOutMinimum: "0",
						sqrtPriceLimitX96: "0"
					}, { value: parseEther(buyAmount) })).hash;


				await ethersProvider.waitForTransaction(hash, 1);
				openNotification("Swap Confirmed", "", { border: 'solid 1px #86EFAC', borderRadius: '18px' });

			} catch (err) {
				console.error(err);
				openNotification("Swap Failed", err.message, { border: 'solid 1px red', borderRadius: '18px' });
			} finally {
				setSwapping(false);
			}
		}
	}


	return (
		!isConnected || (token.protocol === 2 && !token.launchDate) ? <></> :
		<Flex justify="space-between">
				<Button disabled={swapping} variant="solid" style={{ backgroundColor: "#232432", border: "#232432", filter: "drop-shadow(0px 2px 0px #48BB78)"  }} onClick={() => { handleSwap(buy1); } }>{buy1}</Button>
				<Button disabled={swapping} variant="solid" style={{ backgroundColor: "#232432", border: "#232432", filter: "drop-shadow(0px 2px 0px #48BB78)" }} onClick={() => { handleSwap(buy2); }}>{buy2}</Button>
				<Button disabled={swapping} variant="solid" style={{ backgroundColor: "#232432", border: "#232432", filter: "drop-shadow(0px 2px 0px #48BB78)" }} onClick={() => { handleSwap(buy3); }}>{buy3}</Button>
		</Flex>
	)
}

export const Item = ({ value, isKing = false }) => {
	const navigate = useNavigate();
	const { latestEvent } = useSockets();
	const nodeRef = React.useRef(null);
	const [flash, setFlash] = React.useState(false);


	React.useEffect(() => {
		if (value && latestEvent && value.id === latestEvent?.token?.id && latestEvent.message.startsWith("Bought")) {
			setFlash(true);
			setTimeout(() => setFlash(false), 100);
		}
	}, [latestEvent, value]);

	const {
		token: { textGreen, textGray9c, textBlue, textYellow },
	} = theme.useToken();

	if (!value) {
		return (
			<div style={{
				width: '340px',
				height: '180px',
				borderRadius: '18px',
				background: '#161721',
				marginBottom: '20px',
				display: 'flex',
			}}>
				<Spin size="large" style={{ margin: 'auto' }} />
			</div>
		);
	};

	const formatNumber = (value) => {
		return Intl.NumberFormat('en-US', {
			notation: "compact",
			maximumFractionDigits: 1
		}).format(value);
	};

	const lookupChain = (chain) => {
		return ApeConfig.find(x => x.Short === chain || x.ID === chain)?.Short ?? chain;
	}

	return (

		<Col

			style={{ display: 'flex', justifyContent: 'center', height: '180px', marginBottom: '20px'}}
		>
			<CSSTransition timeout={300} in={flash} nodeRef={nodeRef} classNames="ape-flash">				
					<div ref={nodeRef} style={{
				width: '340px',
				height: '180px',
				borderRadius: '18px',
				background: '#161721',
				marginBottom: '20px',
				cursor: 'pointer',
				position: 'realtive',
				border: isKing ? 'none' : value.launchDate !== null ? 'solid 1px #86EFAC' : value.isKing ? 'solid 1px #FFE814' : 'none'
				}}><a href={`/${lookupChain(value.chain)}/${value.address}`} onClick={(evt) => {
						if (!evt.shiftKey && !evt.ctrlKey) {
							evt.preventDefault();
							navigate(`/${lookupChain(value.chain)}/${value.address}`);
						}
				}}>
				<Flex vertical justify="space-between" style={{ height: '100%', width: '100%', padding: '20px' }}>
					<Flex justify="flex-start" align="center" style={{ alignItems: "center" }} >
						<Flex justify="space-between" vertical align="center">
							<TokenLogo value={value} size={100} />
						</Flex>
								<Flex vertical style={{ marginLeft: '10px' }}>
							<Text style={{
								fontSize: '14px',
								fontWeight: 600,
								lineHeight: '20px',
								textAlign: 'left',
								color: '#fff'
							}}>{value?.symbol}</Text>
							{value?.launchDate != null && (value?.protocol === 2 || !value?.marketCap) ?
								<Text style={{
									fontSize: '12px',
									fontWeight: 400,
									lineHeight: '16px',
									textAlign: 'left',
									color: textYellow
								}}>{`Listed on ${ApeConfig.find(x => x.Short === value?.chain || x.ID === value?.chain).DexName}`}</Text> :
								<Text style={{
									fontSize: '12px',
									fontWeight: 400,
									lineHeight: '16px',
									textAlign: 'left',
									color: textGreen
								}}>{`Market Cap: $${formatNumber(value?.marketCap)}`}</Text>
							}
							<Text style={{
								fontSize: '12px',
								fontWeight: 400,
								lineHeight: '16px',
								textAlign: 'left',
								color: textGray9c
							}}>{`replies: ${value?.chatCount}`}</Text>
									<Text title={value?.name} style={{
								fontSize: '14px',
								fontWeight: 500,
								lineHeight: '20px',
								textAlign: 'left',
								color: '#fff',
								overflow: 'hidden',
								whiteSpace: 'nowrap',
								maxWidth: '180px',
								textOverflow: 'ellipsis'
							}}>{value?.name}</Text>
							<Flex>
								<Text style={{
									fontSize: '12px',
									fontWeight: 400,
									lineHeight: '16px',
									textAlign: 'left',
									color: textBlue
									}}>Deployed by</Text>
								<UserIcon address={value?.creator} style={{ width: '18px', height: '18px', marginLeft: '10px' }} />
							</Flex>
						</Flex>
							</Flex>
							<Flex justify="space-between" style={{ width: '100%', marginTop: '20px' }}>
						<Flex justify="flex-start">
							{value.website ? <SocialIcon component={Text} icon={WebIcon} href={value.website} style={{ margin: "5px" }} /> : <></>}
							{value.telegram ? <SocialIcon component={Text} icon={TelegramIcon} href={value.telegram} style={{ margin: "5px" }} /> : <></>}
							{value.twitter ? <SocialIcon component={Text} icon={TwitterIcon} href={value.twitter} style={{ margin: "5px" }} /> : <></>}
							{value.dexPaid ? <SocialIcon component={Text} icon={DexScreenerIcon} href={`https://marketplace.dexscreener.com/order-status/${lookupChain(value.chain)}/${value.address}`} style={{ margin: "5px" }} /> : <></>}
							<div></div>
						</Flex>
						<Flex vertical justify="center" align="right">
							<Flex gap={5}>
								<ProtocolDisplay token={value} />
								<ChainDisplay chain={value.chain} />
							</Flex>
						</Flex>
					</Flex>


						{/*{ isKing == false && (value.launchDate !== null || value.isKing) ? (*/}
						{/*		<Flex vertical justify="space-between" align="flex-end">*/}
						{/*		{ value.launchDate !== null ?*/}
						{/*			<img style={{ width: '40px', height: '30px' }} src="/img/logo.png" /> :*/}
						{/*			<img style={{ width: '46px', height: '46px' }} src="/img/crown.png" />*/}
						{/*		}*/}
						{/*			<Flex gap={5}>*/}
						{/*				<ProtocolDisplay token={value} />*/}
						{/*				<ChainDisplay chain={value.chain} />*/}
						{/*			</Flex>*/}
						{/*	</Flex>*/}
						{/*) : (*/}
						{/*	<Flex vertical justify="flex-end" align="right">*/}
						{/*		<Flex gap={5}>*/}
						{/*			<ProtocolDisplay token={value} />*/}
						{/*			<ChainDisplay chain={value.chain} />*/}
						{/*		</Flex>*/}
						{/*	</Flex>*/}
						{/*)}				*/}
					</Flex>
					</a>
					{value.isStreaming ? <div style={{
						top: '20px',
						position: 'absolute',
						width: '340px',
						display: 'flex',
						justifyContent: 'flex-end',
					}}>
						<Flex vertical>
							<div style={{ width: '50px', background: 'red', textAlign: 'center' }}>● LIVE</div>
							<div style={{ width: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><EyeFilled /> {value.streamViewers}</div>
						</Flex>
					</div> : <></>}
				</div>

			</CSSTransition>
		</Col>
	);
}

